export function parseDelimiterToMarkdown() {
  const delimiter = '----';

  return delimiter.concat('\n');
}

